import React from 'react';
import './PatientInfoPanel.css';
import './PatientPrescriptionSummary.css';

import { MdContentCopy } from 'react-icons/md';  // Material Design clipboard icon
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const PatientAppointmentSummary = ({ patient }) => {

  const statusClassMap = {
    PAID: 'invoice-status-pad-paid',
    PARTIALLY_PAID: 'invoice-status-pad-unpaid',
    UNPAID: 'invoice-status-pad-unpaid',
  };
  
  const statusLabelMap = {
    PAID: 'Payment completed',
    PARTIALLY_PAID: 'Payment Pending',
    UNPAID: 'Payment Pending',
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(patient.mrNumber)
      .then(() => toast.success('MR Number copied to clipboard!'))
      .catch(() => toast.error('Failed to copy MR Number'));
  };

  return (
    <div className="panel-box">
      {/* <h3>Appointment Summary</h3> */}
      <div className="info-row">
        <span className="label">Prescription No</span>
        <span className="colon">:</span>
        <span>-</span>
      </div>
      <div className="info-row">
        <span className="label">Prescription Status</span>
        <span className="colon">:</span>
        <span className={`invoice-status-pad ${patient.prescriptionStatus === 'SAVED' ? 'invoice-status-pad-unpaid' : (statusClassMap[patient.invoiceStatus] || '')}`}>
          {patient.prescriptionStatus === 'SAVED' ? 'Draft Saved (No Invoice)' : (statusLabelMap[patient.invoiceStatus] || patient.invoiceStatus || 'Draft')}
        </span>
      </div>
      <div className="info-row">
        <span className="label">Item Status</span>
        <span className="colon">:</span>
        <span>-</span>
      </div>
      <div className="info-row">
        <span className="label">MR No:</span>
        <span className="colon">:</span>
        <span className="mrnumber">{patient.mrNumber} <button
          className="copy-button"
          onClick={copyToClipboard}
          aria-label="Copy MR Number"
          title="Copy MR Number"
        >
          <MdContentCopy size={20} />
        </button></span>
      </div>

{/* 
      <p>
        <strong>MR No:</strong> {patient.mrNumber}
        <button
          className="copy-button"
          onClick={copyToClipboard}
          aria-label="Copy MR Number"
          title="Copy MR Number"
        >
          <MdContentCopy size={20} />
        </button>
      </p> */}
      {/* <ToastContainer position="top-right" autoClose={2000} hideProgressBar /> */}
    </div>
  );
};

export default PatientAppointmentSummary;
